import { CloseIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import apiDigitacao from "api/api-digitacao";
import { Attendance } from "components/atendimentos-components/atendimento-form/types";
import { CustomModal } from "components/custom-modal";
import DynamicTable from "components/dynamic-table";
import { Column } from "components/dynamic-table/types";
import { useState } from "react";
import { makeEvent, useEventListener } from "services/events";
import { DigitadoRow } from "..";
import { Toast } from "components/toast";
import {
  bgError,
  bgSucess,
  bgWarning,
} from "components/dynamic-table/row-status";
import {
  CustomTableColor,
  CustomTableColorColumn,
} from "components/dynamic-table/color-table";

interface StatusDigitacaoRow {
  datetime: string;
  status: string;
  description?: string;
  status_proposta?: string;
}

interface ModalInitialProps {
  row: DigitadoRow;
  onChangeRow: (k: keyof DigitadoRow | null, v: any) => void;
  statusList?: StatusDigitacaoRow[];
}

export function ModalAcompanharProposta({
  attendance,
}: {
  attendance: Attendance;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let [modalData, setModalData] = useState<Partial<ModalInitialProps>>({});
  const convenio = modalData.row?.convenio;

  const onOpen = async (props: ModalInitialProps) => {
    setIsOpen(true);
    getStatusList(props.row);
    onChange(null, props);
  };

  const onClose = () => {
    setIsOpen(false);
    setModalData({});
  };

  const onChange = (k: keyof ModalInitialProps | null, value: any) => {
    if (k == null) {
      modalData = value;
      setModalData(modalData);
    } else {
      modalData = { ...modalData, [k]: value };
      setModalData(modalData);
    }
  };

  const getStatusList = async (row: DigitadoRow) => {
    const url =
      row.convenio === "INSS"
        ? `/api/digitacoes/inss/consultar-andamento-ade?digitacao_id=${row.id}`
        : row.convenio === "ANTECIPACAO_FGTS"
        ? `/api/digitacoes/fgts/consultar-andamento-ade?digitacao_id=${row.id}`
        : row.convenio === "CONSIGNADO_TRABALHADOR"
        ? `/api/digitacoes/clt/consultar-andamento/proposta/${row.id}`
        : "";

    setIsLoading(true);
    try {
      const { data } = await apiDigitacao.get(url);
      onChange("statusList", data);
      if (data.length) {
        const lastIndex = data.length - 1;
        modalData.onChangeRow?.("lastStatusADE", data[lastIndex].status);
      }
    } catch (e) {
      Toast({
        title: "Erro ao consultar o acompanhamento da proposta",
        description: "Tente novamente",
        status: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEventListener("openModalAcompanharProposta", onOpen);

  const columns: CustomTableColorColumn<StatusDigitacaoRow>[] = [
    {
      name: "Data",
      render: (row) => {
        return new Date(row.datetime).toLocaleString();
      },
    },
    {
      name: "Status",
      render: (row) => {
        return row.description
          ? row.description
          : row.status || row.status_proposta;
      },
    },
  ];

  const modalFooter = (
    <>
      <Button
        variant="outline"
        leftIcon={<CloseIcon w="12px" h="12px" />}
        onClick={onClose}
      >
        Fechar
      </Button>
    </>
  );

  return (
    <CustomModal
      modalTitle="Acompanhar"
      isOpen={isOpen}
      onClose={onClose}
      modalFooter={modalFooter}
      size={"3xl"}
      isLoading={isLoading}
    >
      <CustomTableColor
        columns={columns}
        rows={modalData.statusList || []}
        emptyMessage="Sem dados"
      />
    </CustomModal>
  );
}

export const openModalAcompanharProposta = (props: ModalInitialProps) =>
  makeEvent("openModalAcompanharProposta", props);

const parseCodigo = new Map([
  ["SUCCESS", { desc: "Sucesso", color: bgSucess }],
  ["SYSTEM_ERROR", { desc: "Erro", color: bgError }],
]);
const parseStatus = new Map([
  ["PENDENT", { desc: "Pendente", color: bgWarning }],
  ["FINISHED", { desc: "Finalizado", color: bgSucess }],
  ["SYSTEM_ERROR", { desc: "Erro", color: bgError }],
]);
